import { AxiosResponse } from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Pagination } from "rsuite";

import { Button, Card, Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { EPTable, EPTagPicker } from "../../../common/controls";
import { getAllSkills, getSkillListData } from "../../../common/utils/api";
import { CommonConstants } from "../../../common/utils/CommonConstants";
import { axiosDelete, axiosGet } from "../../../common/utils/helper";
import { UserContext } from "../../layout/layout";
import AddSkillModal from "./AddSkillModal";

function Skill() {
  const { user }: any = useContext(UserContext);
  const PageAccess: string[] =
    user.RoleAccess[location.pathname?.split("/").join("").toLowerCase()];
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [SkillList, setSkillList] = useState([]);
  const [skillListInDropdown, setSkillListInDropDown] = useState([]);
  const [refresher, setRefresher] = useState<boolean>(false);
  const [filterData, setFilterData] = useState<any>({});
  const [limit, setLimit] = useState(10);
  const [pageNo, setPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState(100);

  const tableColumns = [
    {
      key: "Action",
      label: "Action",
      width: 100,
    },
    {
      key: "CreatedDate",
      label: "Created Date",
      sortable: true,
      resizable: true,
      width: 350,
    },
    {
      key: "SkillName",
      label: "Skills",
      sortable: true,
      resizable: true,
      width: 350,
    },

    {
      key: "CreatedBy",
      label: "Created By",
      sortable: true,
      resizable: true,
      flexGrow: 1,
    },
  ];
  interface sortData {
    sortColumn: string;
    sortType: string;
  }
  const [sortData, setSortData] = useState<sortData>({
    sortColumn: "CreatedDate",
    sortType: "desc",
  });

  let response;
  const getSkillList = async (
    reqUrl: string,
    pageNo: number,
    limit: number,
    sortData: sortData,
    filterData?: any
  ) => {
    setLoading(true);
    let reqBody = {
      pageNumber: pageNo,
      limit: limit,
      sortBy: `${sortData.sortColumn}:${sortData.sortType}`,
      filter: JSON.stringify(filterData),
    };
    response = (await axiosGet(reqUrl, reqBody)) as AxiosResponse;
    if (
      response &&
      response.status === CommonConstants.API_RESPONSE_SUCCESSFULL
    ) {
      setLoading(false);
      setSkillList(response.data.data?.SkillData);
      setTotalRecords(response.data.data.length);
    }
  };

  async function getSkillListInDropdown(reqUrl: string) {
    response = (await axiosGet(reqUrl, {})) as AxiosResponse;
    setSkillListInDropDown(response.data.data.data);
  }

  useEffect(() => {
    getSkillListInDropdown(getAllSkills);
  }, [refresher]);

  useEffect(() => {
    getSkillList(getSkillListData, pageNo, limit, sortData, filterData);
  }, [pageNo, refresher, filterData]);

  async function DeleteFunction(reqUrl: string, Id: number) {
    response = (await axiosDelete(`${reqUrl}/${Id}`)) as AxiosResponse;
    if (response.status === CommonConstants.API_RESPONSE_SUCCESSFULL) {
      toast.success("Skill Deleted successfully", {
        position: toast.POSITION.TOP_CENTER,
      });

      // Refresh the dataset based on the current filter
      if (filterData?.SkillID?.includes(Id)) {
        // Remove the deleted record from the filter array
        let updatedFilterData = { ...filterData };
        updatedFilterData.SkillID = updatedFilterData?.SkillID?.filter(
          (skillId: any) => skillId !== Id
        );

        setFilterData(updatedFilterData);
      }

      refresher ? setRefresher(false) : setRefresher(true);
    }
  }

  function handleAddSkillModal() {
    setOpen(true);
  }

  const handleOnChange = (value: string | number, name: string) => {
    let data = { ...filterData };
    data[name] = value;
    setFilterData(data);
    setPageNo(1);
  };

  const handleSortColumn = (sortColumn: string, sortType: string) => {
    sortData["sortColumn"] = sortColumn;
    sortData["sortType"] = sortType;
    const updatedSortData = {
      ...sortData,         // Spread the previous state (this maintains other properties intact)
      sortColumn,          // Update the sortColumn value
      sortType             // Update the sortType value
    };
    setSortData(updatedSortData);
    setLoading(true);
    setPageNo(1);
    getSkillList(getSkillListData, pageNo, limit, sortData, filterData);
  };

  return (
    <Card className="card-managerequest managerequest">
      <Card.Body>
        <div>
          {open && (
            <AddSkillModal
              open={open}
              setOpen={setOpen}
              action={"Add"}
              setRefresher={setRefresher}
              refresher={refresher}
            />
          )}
        </div>
        <Row className="m-1 mb-3">
          <Col xs={12} md={6} lg={3} className="tagpicker-blk me-auto">
            <EPTagPicker
              label="Skill"
              placeholder="Search Skill"
              data={skillListInDropdown}
              onChange={(val: number) => handleOnChange(val, "SkillID")}
              value={filterData?.SkillID}
              displayCount={true}
            />
          </Col>

          {(PageAccess?.includes("Add") || PageAccess?.includes("All")) && (
            <Col xs lg="3" className="text-end ms-auto">
              <Button type="button" onClick={handleAddSkillModal}>
                Add Skill
              </Button>
            </Col>
          )}
        </Row>
        <div className="px-3">
          <EPTable
            setLoading={setLoading}
            PageAccess={PageAccess}
            listName="SkillList"
            columns={tableColumns}
            data={SkillList}
            functionMethod={DeleteFunction}
            sortColumn={sortData.sortColumn}
            sortType={sortData.sortType}
            onSortColumn={handleSortColumn}
            loading={loading}
            rowHeight={40}
            height={455}
            refresher={refresher}
            setRefresher={setRefresher}
          />

          {
            <div style={{ paddingTop: 20 }}>
              <Pagination
                prev
                next
                ellipsis // display 3 dots
                boundaryLinks
                maxButtons={5}
                size="xs"
                layout={["total", "-", "pager"]}
                total={totalRecords}
                limit={limit}
                activePage={pageNo}
                onChangePage={setPageNo}
              />
            </div>
          }
        </div>
      </Card.Body>
    </Card>
  );
}

export default Skill;
